import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked-thin",
  "use": "checked-thin-usage",
  "viewBox": "0 0 18 13",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 13\" id=\"checked-thin\"><path fill-rule=\"evenodd\" d=\"M17.207 1.707 6.5 12.414.793 6.707l1.414-1.414L6.5 9.586 15.793.293z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol